import { BehaviorSubject } from 'rxjs'
import Environment from '@interfaces/environment.interface'
export default new BehaviorSubject<Environment | null>(null)
